var _path, _circle, _circle2, _circle3, _circle4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJ2List(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 76 76"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.3 21h36.8v4H24.3zM24.3 31H49v4H24.3zM24.3 41h36.8v4H24.3zM24.3 51H49v4H24.3z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 23,
    r: 3
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 33,
    r: 3
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 43,
    r: 3
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 53,
    r: 3
  })));
}
export default __webpack_public_path__ + "static/media/J2_List.d7e1dfce.svg";
export { SvgJ2List as ReactComponent };